import { sessionStorage as ss } from '@netlify/app-auth'
import { IconButton } from 'evergreen-ui'

// import Tooltip from '~/components/evergreen/Tooltip'
import ToolGroup from '~/components/ToolGroup'
import { CrossIcon, MaximizeIcon } from '~/icons/evergreen'
import { useActions, useStore } from '~/store/hooks'
import { track } from '~/utils/analytics'
import { messageGift } from '~/utils/messages'
import { capitalize } from '~/utils/string'

type Props = {
  action?: 'close' | 'minimize' | 'expand' | 'dismiss'
  border?: 'left' | 'right'
  icon?: 'expand' | 'close'
}

export default function DockButton(props: Props) {
  let { action } = props
  const { border, icon } = props

  const open = useStore(state => state.hud.toggles.open)
  const close = useActions(actions => actions.hud.close)
  const toggleOff = useActions(actions => actions.hud.toggleOff)
  const setVisibility = useActions(actions => actions.hud.setVisibility)

  if (!action) {
    action = open ? 'close' : 'minimize'
  }

  const click = () => {
    track('drawer_toggle_clicked', {
      toggleName: `dock_${action}`,
      placement: 'dock',
    })

    switch (action) {
      case 'close':
        close()
        setTimeout(() => {
          toggleOff('studio')
          toggleOff('annotate')
          toggleOff('watching')
          messageGift('JAMDOCK_VIEWPORT')
          // the close animation takes 500ms, so setting a value here
          // slightly higher so that the frame resize occurs after animation completion
        }, 550)
        break
      case 'minimize':
        // close()
        setVisibility('minimized')
        ss.set('netlify-cdp-dock-minimized', true)
        setTimeout(() => {
          // TODO: change this to JAMDOCK_MINI_VIEWPORT
          messageGift('JAMDOCK_VIEWPORT')
          // the close animation takes 500ms, so setting a value here
          // slightly higher so that the frame resize occurs after animation completion
        }, 550)
        break
      case 'expand':
        setVisibility('showing')
        ss.remove('netlify-cdp-dock-minimized')
        messageGift('JAMDOCK_VIEWPORT')
        break
      case 'dismiss':
        setVisibility('dismissed')
        setTimeout(() => {
          messageGift('SELF_DESTRUCT')
        }, 550)
        break
      default:
        break
    }
  }

  return (
    <ToolGroup border={border}>
      <IconButton
        appearance="minimal"
        aria-label={capitalize(action)}
        icon={icon === 'expand' ? MaximizeIcon : CrossIcon}
        marginX={8}
        onClick={click}
        title={capitalize(action)}
      />
    </ToolGroup>
  )
}
